/**
 * Application header component
 * Displays app title, tagline, and construction badge
 */
import { APP_CONFIG } from '../lib/constants';
import { Construction } from 'lucide-react';

export function Header() {
  return (
    <header className="w-full px-4 py-8 text-center" role="banner">
      <h1 className="text-4xl md:text-5xl font-bold mb-2">
        <a 
          href="https://shaketolearn.com" 
          className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent hover:from-primary/80 hover:to-accent/80 transition-all duration-200"
          aria-label="Shake To Learn - Home"
        >
          {APP_CONFIG.name}
        </a>
      </h1>
      <p className="text-sm md:text-base text-muted-foreground max-w-2xl mx-auto">
        {APP_CONFIG.description}
      </p>
      <div className="flex items-center justify-center gap-2 mt-3 mb-1">
        <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-600 dark:text-amber-400 text-xs font-medium">
          <Construction className="w-3 h-3" />
          <span>Under Construction</span>
        </div>
      </div>
      <p className="text-xs text-muted-foreground/70 mt-2">
        By{' '}
        <a 
          href="https://whiskerbyte.com"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-foreground transition-colors underline decoration-dotted"
          aria-label="whiskerByte - Professional App Development"
        >
          whiskerByte
        </a>
      </p>
    </header>
  );
}

